import { i18next } from '@frontend/i18n';
import { AnalyticsDataKey } from './types';

export const labels = {
  [AnalyticsDataKey.TotalCalls]: i18next.t('Total Calls', { ns: 'analytics-phone' }),
  [AnalyticsDataKey.AnsweredCalls]: i18next.t('Calls Answered', { ns: 'analytics-phone' }),
  [AnalyticsDataKey.MissedCalls]: i18next.t('Calls Missed', { ns: 'analytics-phone' }),
  [AnalyticsDataKey.AbandonedCalls]: i18next.t('Calls Abandoned', { ns: 'analytics-phone' }),
} as const;

export const chartColumnHeaders = {
  [AnalyticsDataKey.TotalCalls]: i18next.t('Total Calls', { ns: 'analytics-phone' }),
  [AnalyticsDataKey.AnsweredCalls]: i18next.t('Answered Calls', { ns: 'analytics-phone' }),
  [AnalyticsDataKey.MissedCalls]: i18next.t('Missed Calls', { ns: 'analytics-phone' }),
  [AnalyticsDataKey.AbandonedCalls]: i18next.t('Abandoned Calls', { ns: 'analytics-phone' }),
  groupNameHeader: '',
} as const;

export const rateLabels = {
  [AnalyticsDataKey.AnsweredCalls]: i18next.t('Answer Rate', { ns: 'analytics-phone' }),
  [AnalyticsDataKey.MissedCalls]: i18next.t('Miss Rate', { ns: 'analytics-phone' }),
  [AnalyticsDataKey.AbandonedCalls]: i18next.t('Abandoned Rate', { ns: 'analytics-phone' }),
} as const;

export const commonLabels = {
  devices: i18next.t('Devices', { ns: 'analytics-phone' }),
  answerRate: i18next.t('Answer Rate', { ns: 'analytics-phone' }),
  missedRate: i18next.t('Missed Rate', { ns: 'analytics-phone' }),
  abandonedRate: i18next.t('Abandoned Rate', { ns: 'analytics-phone' }),
} as const;
